"use client";

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from "react";
import { useUnreadNotifications } from "./useUnreadNotifications";
import { useMyStream } from "@/contexts/wave/MyStreamContext";
type UnreadIndicatorType = "notifications" | "messages";
interface UseUnreadIndicatorProps {
  readonly type: UnreadIndicatorType;
  readonly handle: string | null;
}
interface UseUnreadIndicatorReturn {
  readonly hasUnread: boolean;
}
export function useUnreadIndicator(t0) {
  const $ = _c(8);
  const {
    type,
    handle
  } = t0;
  const [hasUnread, setHasUnread] = useState(false);
  const {
    haveUnreadNotifications
  } = useUnreadNotifications(type === "notifications" ? handle : null);
  const {
    directMessages
  } = useMyStream();
  let t1;
  let t2;
  if ($[0] !== directMessages.list || $[1] !== handle || $[2] !== haveUnreadNotifications || $[3] !== type) {
    t1 = () => {
      if (!handle) {
        setHasUnread(false);
        return;
      }
      if (type === "notifications") {
        setHasUnread(haveUnreadNotifications);
      } else {
        if (type === "messages") {
          const hasUnreadMessages = directMessages.list.some(_temp);
          setHasUnread(hasUnreadMessages);
        }
      }
    };
    t2 = [type, handle, haveUnreadNotifications, directMessages.list];
    $[0] = directMessages.list;
    $[1] = handle;
    $[2] = haveUnreadNotifications;
    $[3] = type;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== hasUnread) {
    t3 = {
      hasUnread
    };
    $[6] = hasUnread;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp(dm) {
  return (dm?.unreadDropsCount ?? 0) > 0 || (dm?.newDropsCount?.count ?? 0) > 0;
}